/// <amd-module name="Wit/WorkItemForm/Attachments/Dialogs/DeleteAttachmentDialog" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { Dialog } from "VSSUI/Dialog";
import * as Resources from "Wit/WorkItemForm/Resources";

export interface IDeleteCommentDialogProps {
    attachmentName: string;
    onConfirmDelete: () => void;
    onDismiss: () => void;
}

export function DeleteAttachmentDialog({ attachmentName, onConfirmDelete, onDismiss }: IDeleteCommentDialogProps) {
    return (
        <Dialog
            lightDismiss
            escDismiss
            titleProps={{ text: Resources.DeleteAttachment }}
            footerButtonProps={[
                {
                    text: Resources.ConfirmDeleteAttachment,
                    onClick: onConfirmDelete,
                    primary: true
                },
                {
                    text: Resources.CancelDeleteAttachment,
                    onClick: onDismiss
                }
            ]}
            onDismiss={onDismiss}
        >
            {format(Resources.ConfirmDeleteAttachmentPrompt, attachmentName)}
        </Dialog>
    );
}
